import MedicareGlp1Coverage from "./pages/MedicareGlp1Coverage";
import Glp1OnlineSafety from "./pages/Glp1OnlineSafety";
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Navigate, Routes, Route } from "react-router-dom";
import { Suspense } from "react";
import { Helmet } from "react-helmet-async";
import { Index, CompoundsPage, CompoundDetail, AboutPage, BlogPage, BlogPost,
  PrivacyPolicy, TermsOfService, ResearchDisclaimer, IntelligenceHub,
  IntelligenceArticle, NotFound, RetatrutideTracker, CompareGlp1, Glp1Cost,
  PolicyPage, ResearchRetatrutide, Disclosures, EditorialPolicy, PeptideHorizon, HhsPolicy, HhsProposal, HhsPeptideDraftPolicy, FoundayoVsWegovyPill, CagrisemaResults, CompoundedSemaglutideStatus, AlertsHub, AlertDetail } from "./routePages";
import LegacyHorizonRedirect from "./components/seo/LegacyHorizonRedirect";
import { Comparison503, Lipfendra, CompoundedTirzepatideStatus, RfkPeptides } from "./routePages";
import RedirectTo from "./components/seo/RedirectTo";
import Footer from "@/components/sections/Footer";
import SiteHeader from "@/components/layout/Navbar";
import StickyAlertBar from "@/components/layout/StickyAlertBar";

const queryClient = new QueryClient();

export function AppRoutes() {
  return (
    <>
    <Helmet defaultTitle="PeptideX: Peptide Research & FDA Status" />
    <SiteHeader />
    <Suspense fallback={<div role="status" className="min-h-screen bg-background flex items-center justify-center text-foreground">Loading…</div>}>
    <Routes>
      <Route path="/" element={<Index />} />
      <Route path="/compounds" element={<CompoundsPage />} />
      <Route path="/compounds/cjc-1295-ipamorelin" element={<Navigate to="/compounds/cjc-1295" replace />} />
      <Route path="/compounds/:slug" element={<CompoundDetail />} />
      <Route path="/about" element={<AboutPage />} />
      <Route path="/blog" element={<BlogPage />} />
      <Route path="/blog/:slug" element={<BlogPost />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/terms" element={<TermsOfService />} />
      <Route path="/disclaimer" element={<ResearchDisclaimer />} />
      <Route path="/disclosures" element={<Disclosures />} />
      <Route path="/editorial-policy" element={<EditorialPolicy />} />
      <Route path="/retatrutide-tracker" element={<RetatrutideTracker />} />
      <Route path="/compare/retatrutide-vs-zepbound-mounjaro-wegovy" element={<CompareGlp1 />} />
      <Route path="/glp-1-online-safety" element={<Glp1OnlineSafety />} />
      <Route path="/medicare-glp-1-coverage" element={<MedicareGlp1Coverage />} />
      <Route path="/glp-1-cost" element={<Glp1Cost />} />
      <Route path="/policy" element={<PolicyPage />} />
      <Route path="/policy/hhs-503a-peptides-2026" element={<HhsPolicy />} />
      <Route path="/hhs-peptide-draft-policy" element={<HhsPeptideDraftPolicy />} />
      <Route path="/foundayo-vs-wegovy-pill" element={<FoundayoVsWegovyPill />} />
      <Route path="/cagrisema-results" element={<CagrisemaResults />} />
      <Route path="/compounded-tirzepatide-status" element={<CompoundedTirzepatideStatus />} />
      <Route path="/rfk-peptides" element={<RfkPeptides />} />
      <Route path="/compounded-semaglutide-status" element={<CompoundedSemaglutideStatus />} />
      <Route path="/compounded-semaglutide-status" element={<CompoundedSemaglutideStatus />} />
      <Route path="/hhs-503a-peptides" element={<HhsProposal />} />
      <Route path="/503a-vs-503b" element={<Comparison503 />} />
      <Route path="/lipfendra" element={<Lipfendra />} />
      <Route path="/alerts" element={<AlertsHub />} />
      <Route path="/alerts/:slug" element={<AlertDetail />} />
      <Route path="/research-retatrutide-legal-safe" element={<ResearchRetatrutide />} />
      <Route path="/peptide-horizon" element={<PeptideHorizon />} />
      <Route path="/body-map" element={<LegacyHorizonRedirect />} />
      <Route path="/body-map/:area" element={<LegacyHorizonRedirect />} />
      <Route path="/intelligence" element={<IntelligenceHub />} />
      <Route path="/intelligence/:slug" element={<IntelligenceArticle />} />
      <Route path="/access" element={<RedirectTo to="/policy?notice=access" />} />
      <Route path="/sourcing" element={<RedirectTo to="/policy?notice=sourcing" />} />
      <Route path="/sourcing/regulatory-landscape" element={<RedirectTo to="/policy" />} />
      {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
      <Route path="*" element={<NotFound />} />
    </Routes>
    </Suspense>
    <Footer />
    <StickyAlertBar />
    </>
  );
}

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
